import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import PageTitle from 'components/PageTitle'
import LoginForm from './LoginForm'
import wabenzyLogo from '../img/wabenzy-logo.png'

class LoginPage extends Component {
  handleHome = e => {
    e.preventDefault()
    // eslint-disable-next-line react/prop-types
    this.props.history.push('/')
  }

  render() {
    return (
      <div className="auth">
        {/* Outside the dashboard layout, so there is no route floor here to inherit. */}
        <PageTitle title="Sign in" />
        <div className="auth__bounding-box">
          <div className="auth__top">
            <img
              src={wabenzyLogo}
              alt="Wabenzy Autos Logo"
              className="bq-logo bq-logo--auth mb-1rem"
              style={{ width: '15rem' }}
              // eslint-disable-next-line react/prop-types
              onClick={() => this.props.history.push('/')}
            />
          </div>
          <div>
            <hr />
          </div>
          <div className="auth__caption mb-5rem">
            <h2>Wabenzy Autos Manager</h2>
            <small>Login to proceed</small>
          </div>

          <LoginForm />

          {/* <div className="auth__footer mb-1rem">
            <div className="mr-2rem">
              Don't have an account?{' '}
              <Link to="/auth/signup">
                <span className="navbar__link--active">Register Now</span>
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    )
  }
}

LoginPage.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func
  })
}

export default withRouter(LoginPage)
